/**
 * Phone runtime release changelog from packages/phone/releases manifests.
 * Bundled at build time so dash stays offline-friendly and always has notes.
 */

import {
  normalizePhoneReleaseManifest,
  sortPhoneReleaseManifests,
  type PhoneReleaseManifest,
  type RawPhoneReleaseManifest,
} from "./phone-runtime-changelog-pure";

export type {
  PhoneReleaseManifest,
  RawPhoneReleaseManifest,
} from "./phone-runtime-changelog-pure";
export {
  compareSemverDesc,
  normalizePhoneReleaseManifest,
  sortPhoneReleaseManifests,
} from "./phone-runtime-changelog-pure";

// Vite resolves this glob at build/dev time to every release manifest.
const manifestModules = import.meta.glob<RawPhoneReleaseManifest>(
  "../../../../packages/phone/releases/*/manifest.json",
  { eager: true, import: "default" },
);

/** All release manifests, newest version first. */
export function listPhoneReleaseManifests(): PhoneReleaseManifest[] {
  const items: PhoneReleaseManifest[] = [];
  for (const mod of Object.values(manifestModules)) {
    const item = normalizePhoneReleaseManifest(mod ?? {});
    if (item) items.push(item);
  }
  return sortPhoneReleaseManifests(items);
}
